import { NCWalletTabs } from '@capsicum/common';

const reverseNCWalletTabs = Object.values(NCWalletTabs);

export const isNCWalletTabs = (name: unknown): name is NCWalletTabs =>
	(reverseNCWalletTabs as Array<unknown>).includes(name);
